import { Injectable, EventEmitter } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestMethod, Request, ResponseContentType } from '@angular/http';
import { Observable, Observer } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { AppConfig } from '../boot/app.config';
import { IDashboardData, IETLData } from '../viewsmodule/interfaces';
import { Router, ActivatedRoute } from '@angular/router';
import { LOGIN } from '../utils/utils';
import * as moment from 'moment/moment';

@Injectable()
export class DataService {
    _baseUrl: string = '';
    //_baseUrl: string = 'http://plex.bts.com/dataservice/';
    public token: string = null;
    public dashboards: Array<any> = [];
    public dashboardData: IDashboardData;
    public etlData: IETLData[];
    public participantPageSize: number = 2;

    constructor(private http: Http, private config: AppConfig, private router: Router) { }

    // ===================================================
    /* authentication */
    authenticate(username: string, password: string): Observable<any> {
        this._baseUrl = this.config.getConfig('hostName') || '';
        localStorage.setItem('dashboardLoginType', 'normal');
        // authenticate user
        //return this.http.get(this._baseUrl+'dashboardLogin?user='+username+'&pass='+password)
        return this.http.post(this._baseUrl + 'dashboardLogin', { user: username, pass: password })
            .map(this.authenticateResult)
            .catch(this.handleError);
    }

    authenticatesso(token: string) {
        this._baseUrl = this.config.getConfig('hostName') || '';
        localStorage.setItem('dashboardLoginType', 'sso');
        // authenticate user via sso
        return this.http.post(this._baseUrl + 'consumeSAML', { token: token })
            .map(this.authenticateResult)
            .catch(this.handleError);
    }

    private authenticateResult(response: Response | any) {
        if (response instanceof Response) {
            let user = response.json();
            if (user && user.token) {
                this.token = user.token;
                //store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('dashboardUser', user.token);
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    private handleError = (error: Response | any) => {
        // In a real world app, we might use a remote logging infrastructure
        //console.log(">>>>>>>>handleError");
        let errMsg;
        if (error instanceof Response) {
            // const body = error.json() || '';
            // const err = body.error || JSON.stringify(body);
            // errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            //console.log(">>>>>>>>response "+error.status);

            if (error.status == 403) {
                this.logout(null, null);
            }
        } else {
            //     console.error(errMsg);
            errMsg = error.message ? error.message : error.toString();
            return Observable.throw(errMsg);
        }
    }

    // =============================================================
    /* get configurations */
    getConfiguration(): Observable<any> {
        //console.log(">>>>>>>>getConfiguration");
        this._baseUrl = this.config.getConfig('hostName') || '';
        var token = localStorage.getItem('dashboardUser');
        var body = {
            "token": token,
        };
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var options = new RequestOptions({ headers: headers });
        var params = JSON.stringify(body);

        return this.http.post(this._baseUrl + 'getConfigurations', params, options)
            .map(response => this.dashboards = response.json())
            .catch(this.handleError);
    }

    // private configurationResult(response: Response | any){
    //     var self = this;
    //     console.log(">>>>>>>>configurationResult");
    //     if (response instanceof Response) {
    //         this.dashboards = response.json();
    //         console.log(this.dashboards);
    //     }
    //     return true;
    // }

    getDashboardData(dashboardId: string, questions: string, fromDate: Date, toDate: Date, experienceIds, customLogic, region = "", selectedCompany = "", selectedFilterQuestion, columnType = ""): Promise<any> {
        var token = localStorage.getItem('dashboardUser');
        var self = this;
        var startDate: string = fromDate.toISOString();
        var endDate: string = moment(toDate).add(1, 'day').subtract(1, 'seconds').toISOString();
        if (customLogic !== undefined) {
            customLogic = JSON.stringify(customLogic)
        }
        else {
            customLogic = "";
        }
        if (selectedFilterQuestion) {
            selectedFilterQuestion = JSON.stringify(selectedFilterQuestion);
        }

        var body = {
            "token": token,
        };
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var options = new RequestOptions({ headers: headers });
        var params = JSON.stringify(body);
        return this.http.post(this._baseUrl + 'getDashboard?dashboardId=' + dashboardId + '&metrics=' + questions + '&fromDate=' + startDate + '&toDate=' + endDate + '&experienceIds=' + experienceIds + '&customLogic=' + customLogic + '&region=' + region + '&selectedCompany=' + selectedCompany + '&filterQuestions=' + selectedFilterQuestion + '&columnType=' + columnType, params, options)
            .map((response) => this.setDashboardData(response))
            .toPromise()
            .catch(this.handleError);
    }

    setDashboardData(response: Response): IDashboardData {
        let etlData = response.json().data.recordset;
        this.dashboardData = {
            dashboard: response.json().dashboard,
            recordSet: etlData
        }
        return this.dashboardData;
    }

    getParticipantData(id: any, pNo: number, eventTitle: string, searchOn: Array<string>, fixedKeys: Array<string>, questions: Array<string>, defaultSortColumn: string, defaultSortOrder: string, searchText: string, searchOnQuestions: Array<string>, fromDate: any, toDate: any, filterOnCompany: boolean, selectedCompany: number, filters: Array<string>, filterValue: any) {
        var token = localStorage.getItem('dashboardUser');
        var userId = localStorage.getItem('userId');

        var body = {
            "dashboardId": id,
            "token": token,
            "eventTitle": eventTitle,
            "searchText": searchText,
            "fixedKeys": fixedKeys,
            "questions": questions,
            "searchOn": searchOn,
            "searchOnQuestions": searchOnQuestions,
            "pageSize": this.participantPageSize,
            "defaultSortColum": defaultSortColumn,
            "defaultSortOrder": defaultSortOrder,
            "pageIndex": pNo,
            "fromDate": fromDate || null,
            "toDate": toDate || null,
            "userId": userId,
            "filterOnCompany": filterOnCompany,
            "selectedCompany": selectedCompany,
            "filters": filters,
            "filterValue": JSON.stringify(filterValue)
        };

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var options = new RequestOptions({ headers: headers });
        var params = JSON.stringify(body);

        return this.http.post(this._baseUrl + 'getExperienceData', params, options)
            .map((response) => response.json())
            .catch(this.handleError);
    }

    downloadReport(id: any, eventTitle: string, reportIds: Array<String>) {
        var token = localStorage.getItem('dashboardUser');

        var body = {
            "dashboardId": id,
            "token": token,
            "eventTitle": eventTitle,
            "reportIds": reportIds
        };

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
        var params = JSON.stringify(body);

        return this.http.post(this._baseUrl + 'downloadExperienceReport', params, options)
            .map((response) => {
                return new Blob([response.blob()], { type: 'application/pdf' });
            })
            .catch(this.handleError);
    }

    getServerDetails(eventTitle: string) {

        return this.http.get(this._baseUrl + 'getServerDetails?eventTitle=' + eventTitle)
            .map((response) => {
                return response;
            })
            .catch(this.handleError);
    }

    getServerUrl() {
        return this._baseUrl;
    }

    downloadVideo(id: any, eventTitle: string, videoConfig: string) {
        var token = localStorage.getItem('dashboardUser');

        var body = {
            "dashboardId": id,
            "token": token,
            "eventTitle": eventTitle,
            "videoConfig": videoConfig
        };

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
        var params = JSON.stringify(body);

        return this.http.post(this._baseUrl + 'downloadVideo', params, options)
            .map((response) => {
                return new Blob([response.blob()], { type: 'application/pdf' });
            })
            .catch(this.handleError);
    }

    logout(returnUrl, queryParams) {
        this.token = null;
        localStorage.clear();
        let url = LOGIN;
        if (returnUrl && returnUrl != '/') {
            returnUrl = returnUrl.replace(/\//g, '%2F')

            url += ";";
            url += "returnUrl=";
            url += returnUrl;

            if (queryParams) {
                url += "?";
                var queryString = '';

                for (var i = 0; i < Object.entries(queryParams).length; i++) {
                    var objArr = Object.entries(queryParams)[i];
                    for (var j = 0; j < objArr.length; j++) {
                        queryString += objArr[j];
                        if (j < objArr.length - 1) {
                            queryString += "=";
                        }
                    }

                    if (i < Object.entries(queryParams).length - 1) {
                        queryString += '&';
                    }
                }

                url += queryString;
            }
        }

        this.router.navigateByUrl(url);
        //console.log("Cookies cleared.");
        return false;
    }

    private _observables: any = {};

    emitData(key: string, calculatedData: Array<any>) {
        if (this._observables[key]) {
            this._observables[key].emit(calculatedData);
        }
    }

    getObservable(key: string): any {
        if (key) {
            return this._observables[key] = new EventEmitter();
        }
    }

    getFiltersQuestionsResponse(experience, questions): any {
        var token = localStorage.getItem('dashboardUser');
        var self = this;
        return this.http.post(this._baseUrl + 'getFiltersQuestionsResponse?token=' + token, { questions: questions, experience: experience })
            .map((response) => this.setDashboardData(response))
            .toPromise()
            .catch(this.handleError);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/data.service.ts